import { render } from "./PdfDocument.vue?vue&type=template&id=668ccc64"
import script from "./PdfDocument.vue?vue&type=script&lang=js"
export * from "./PdfDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__